var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('app-header'),(_vm.isLoading)?_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"spinner spinner-1"})]):_vm._e(),_c('router-view'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }